import React, { SVGProps } from "react";

const SvgRoof1 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 300" {...props}>
    <path fill="none" d="M0 0h350v300H0z" />
    <g data-name="roof001 dims 1">
      <path
        fill="#aec0cf"
        d="M137.526 201.829v33.664l174.053-100.6v-33.664l-174.053 100.6z"
      />
      <path
        fill="#fff"
        d="M137.526 201.829v33.664l-99.287-57.189v-44.045l44.627-18.09 54.66 85.66z"
      />
      <g fill="#6d9faf">
        <path d="M86.69 138.03v10.016l-8.327-4.797v-10.015l8.327 4.796zM96.89 143.919v10.016l-8.327-4.796v-10.016l8.327 4.796zM86.69 150.026v10.015l-8.327-4.796v-10.016l8.327 4.797zM96.89 155.915v10.015l-8.327-4.796v-10.016l8.327 4.797z" />
      </g>
      <path
        fill="#247cad"
        d="M321.601 95.305 137.526 201.829l-55.164-85.385L266.841 10l54.76 85.305z"
      />
      <path
        fill="#46d4ff"
        d="M266.841 10 82.362 116.444l-54.261 21.95L212.43 31.862 266.841 10z"
      />
      <g fill="none">
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          d="M137.526 235.493v-33.664"
        />
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M38.239 134.259v44.045l99.287 57.189 174.053-100.6v-33.665"
        />
        <path
          stroke="#002839"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M266.841 10 212.43 31.862 28.101 138.394l54.261-21.95 55.164 85.385L321.601 95.305 266.841 10z"
        />
        <path
          stroke="#002839"
          strokeMiterlimit={10}
          d="M82.737 115.757 266.841 10"
        />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m109.254 251.829 19.115-11.048M10 194.659l19.07-11.09M14.932 192.123l98.5 56.736" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m165.966 251.829-19.116-11.048M340 151.485l-19.07-11.091M335.009 148.983l-173.417 99.989" />
      </g>
      <text
        transform="translate(258.776 207.087)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"B"}
      </text>
      <text
        transform="translate(28.743 114.01)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"P"}
      </text>
      <path
        d="M35.553 135.159c-9.31-17.943-14.84-37.345-14.913-54.675M77.269 113.158 15.13 77.27M24.114 78.474l-6.928 4M36.475 131.301l-1.808 7.793"
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <text
        transform="translate(51.811 231.494)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"A"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M14.779 187.908v8M113.85 245.051v8M161.478 244.966v8M335.325 144.761v8"
      />
    </g>
  </svg>
);

export default SvgRoof1;
